Ext.define('SA.view.mapexport.SizeField', {
    alias: 'widget.export-size-field',
    extend: 'SA.view.mapexport.UnitsField',

    initComponent() {
        var details = this.details;

        this.callParent();

        this.refresh();

        this.mon(details, 'set:units', this.refresh, this);
        this.mon(details, 'set:' + this.name, this.refresh, this);
    },

    afterRender() {
        this.callParent();

        this.mon(this.inputEl, 'blur', this.onInputBlur, this);
    },

    onInputBlur() {
        this.fireEvent('inputblur', this);
    },

    refresh() {
        this.setUnits(this.details.getUnits());
    },

    setUnits(units) {
        this.callParent([units]);

        if (units === 'inches') {
            this.allowDecimals = true;
            this.decimalPrecision = 3;
        }
        else {
            this.allowDecimals = false;
            this.decimalPrecision = 0;
        }

        this.setMinValue(0);

        this.setValue(this.details.getDisplaySize(this.name));
    }
});